"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import {globalStyles} from "../../styles/global";
var heightSize = function heightSize(size) {
  switch (size) {
    case 'xs':
      return "38px";

    case "sm":
      return "48px";

    case "lg":
      return "60px";

    default:
      return "48px";
    //sm
  }
};

var textFontSize = function textFontSize(size) {
  switch (size) {
    case 'xs':
      return "12px";

    case "sm":
      return "16px";

    case "lg":
      return "18px";

    default:
      return "16px";
    //sm
  }
};

var messageFontSize = function messageFontSize(size) {
  switch (size) {
    case 'xs':
    case "sm":
      return "12px";

    case "lg":
      return "14px";

    default:
      return "12px";
    //sm
  }
};

var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  dLWrapper: {
    position: "relative"
  },
  dLHeader: function dLHeader(props) {
    return {
      fontFamily: "IranSansX",
      fontSize: textFontSize(props.size),
      color: _variables.colors.night,
      width: "100%",
      height: heightSize(props.size),
      border: "1px solid ".concat(props.err ? _variables.colors.fire : _variables.colors.hare),
      borderRadius: "10px",
      padding: props.size === "xs" ? "18px 16px" : "23px 16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      direction: "rtl",
      cursor: "pointer",
      backgroundColor: _variables.colors.ghost
    };
  },
  angle: function angle(props) {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: "rotate(".concat(props.flag ? "90deg" : "180deg", ")"),
      transition: "0.3s ease all"
    };
  },
  dlList: function dlList(props) {
    return {
      width: "100%",
      fontFamily: "IranSansX",
      fontSize: textFontSize(props.size),
      color: _variables.colors.night,
      marginTop: "10px",
      position: "absolute",
      zIndex: "20"
    };
  },
  searchBox: {
    position: "relative"
  },
  searchBar: function searchBar(props) {
    return {
      width: "100%",
      fontFamily: "IranSansX",
      fontSize: "14px",
      height: heightSize(props.size),
      color: _variables.colors.wolf,
      backgroundColor: _variables.colors.swan,
      borderRadius: "10px 10px 0 0",
      border: "none",
      direction: "rtl",
      textIndent: "60px"
    };
  },
  searchIcon: function searchIcon(props) {
    return {
      position: "absolute",
      top: "30%",
      right: "20px",
      '& svg': {
        width: props.size === "xs" ? "15px" : 'unset',
        height: props.size === "xs" ? "15px" : 'unset'
      }
    };
  },
  scrollList: function scrollList(props) {
    return {
      borderRadius: props.searchable ? "0 0 10px 10px" : "10px",
      borderTop: props.searchable ? "unset" : "1px solid ".concat(_variables.colors.hare),
      border: "1px solid ".concat(_variables.colors.hare),
      direction: "rtl",
      maxHeight: props.size === "xs" ? "35vh" : "50vh",
      overflow: "auto"
    };
  },
  dLListItem: function dLListItem(props) {
    return {
      width: "100%",
      height: heightSize(props.size),
      fontFamily: "IranSansX",
      fontSize: textFontSize(props.size),
      color: _variables.colors.night,
      padding: props.size === "xs" ? "18px 16px" : "23px 16px",
      display: "flex",
      direction: "rtl",
      cursor: "pointer",
      backgroundColor: _variables.colors.ghost,
      border: "none",
      alignItems: "center",
      '&:hover': {
        backgroundColor: _variables.colors.swan
      }
    };
  },
  err: function err(props) {
    return {
      color: _variables.colors.fire,
      fontSize: messageFontSize(props.size),
      fontFamily: "IranSansX",
      direction: "rtl",
      margin: props.size === "xs" ? "4px 16px 0 0" : props.size === "sm" ? "4px 16px 0 0" : "10px 16px 0 0"
    };
  },
  helper: function helper(props) {
    return {
      color: _variables.colors.wolf,
      fontSize: messageFontSize(props.size),
      direction: "rtl",
      fontFamily: "IranSansX",
      margin: props.size === "xs" ? "4px 16px 0 0" : props.size === "sm" ? "4px 16px 0 0" : "10px 16px 0 0"
    };
  },
  label: function label(props) {
    return {
      backgroundColor: _variables.colors.ghost,
      position: props.singleSelect ? "absolute" : "unset",
      visibility: "visible",
      top: props.singleSelect ? "-10px" : "unset",
      right: props.singleSelect ? "10px" : "unset",
      padding: props.singleSelect ? "0 10px 0 10px" : "unset",
      fontSize: props.singleSelect && props.size === "lg" ? "14px" : props.singleSelect && props.size === "sm" ? "12px" : props.singleSelect && props.size === "xs" ? "12px" : "unset",
      transition: "0.2s ease all",
      color: _variables.colors.wolf
    };
  },
  multiplePicked: function multiplePicked(props) {
    return {
      fontFamily: "IranSansX",
      fontSize: props.size === "xs" ? "10px" : props.size === "sm" ? "12px" : "14px",
      padding: props.size === "xs" ? "3px 15px" : props.size === "sm" ? "5px 15px" : "10px 30px",
      backgroundColor: _variables.colors.hare,
      borderRadius: "10px",
      margin: "0 10px 0 10px"
    };
  },
  multipleBox: {
    display: "flex",
    alignItems: "center"
  },
  loading: function loading(props) {
    return {
      height: heightSize(props.size),
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(6px)",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      borderRadius: "10px"
    };
  }
}), {
  name: 'pds-multiple-dl'
});
exports.useStyles = useStyles;